import React, {useEffect, useState} from 'react';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { Menu, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import {useAppSelector} from "../../app/hooks";
import {selectUser} from "../auth/authSlice";

const defaultMenuItems: ItemType[] = [
  {
    key: 'changelog',
    label: (
      <Typography.Link href="https://git.tuzhi.ai/tuzhi/tuzhi-backend/-/releases" target="_blank" rel="noreferrer">
        更新日志
      </Typography.Link>
    ),
  },
  {
    key: 'admin',
    label: (
      <Link to="/admin/user">
        管理后台
      </Link>
    ),
  },
];

export default function RightMenu() {
  const { md } = useBreakpoint();

  // 按权限隐藏对应功能
  const user = useAppSelector(selectUser);
  const [menuItems, setMenuItems] = useState(defaultMenuItems);

  useEffect(() => {
    if (user.role !== 'SUPER_ADMIN') {
      setMenuItems(defaultMenuItems.filter(item => item?.key !== 'admin'));
    }
  }, [user]);

  return (
    <Menu theme="dark" mode={md ? 'horizontal' : 'inline'} items={menuItems} />
  );
}
